import React, { useEffect, useState} from "react";
import ReactSelectAsync from "../../../../Components/Inputs/ReactSelectAsync";
import ReactSelectInput from "../../../../Components/Inputs/ReactSelectInput";
import axios from "axios";
import TextareaInput from "../../../../Components/Inputs/TextareaInput";
import NumberInput from "../../../../Components/Inputs/NumberInput";
import ProductShopAddresses from "./ProductShopAddresses";

export default function ({register, watch, setValue, errors, control, data, index = null, handleSave, close, update}) {
  const [oldData, setOldData] = useState({...watch(`products.${index}`)});
  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (JSON.stringify(watch(`products.${index}`)?.id)) {
      searchProducts([watch(`products.${index}`)?.id], null, true)
    }
  }, [JSON.stringify(watch(`products.${index}`)?.id)])

  const searchProducts = (productIds, keyword, updateProducts = false) => {
    return axios.get('search-products-list',
      {
        params: {
          product_ids: productIds.filter(Number),
          categories: watch('categories'),
          only_discounted: watch('only_discounted') ? 1 : 0,
          keyword: keyword
        }
      }).then(res => {
      if (res.data.status === 'success') {
        if (updateProducts) {
          setProducts(res.data.products)
        }
        return filterProducts(null, res.data.products);
      }
    });
  }

  const filterProducts = (selectedProductId, products) => {
    return products?.filter(item => {
      let selectedProductIds = watch('products').map((item) => {
        if (selectedProductId !== item.id) {
          return item.id
        }
      })

      return (item.id !== selectedProductIds.find(id => item.id === id))
    });
  }

  const fetchProductInfo = (productId) => {
    axios.get(`products/${productId}/info`).then(res => {
      if (res.data.status === 'success') {
        let product = res.data.product;

        let newValues = {...watch(`products.${index}`),
          ...product,
          product_price: parseFloat(product.price),
          dealing_price: parseFloat(product.dealing_price || 0)
        }
        update(index, newValues)
        setValue(`products.${index}`, newValues)
      }
    })
  }

  useEffect(() => {
    if (JSON.stringify(oldData) !== JSON.stringify(watch(`products.${index}`))) {
      setValue(`products.${index}.is_modified`, true)
    }
  }, [JSON.stringify(watch(`products.${index}`))])

  return (
    <div className="card py-4 mt-3">
      <div className="card-body pt-0">
        <div className="row pb-5">
          <div className='w-100'>
            <input type="hidden" name={`products.${index}.is_modified`}/>
            <ReactSelectAsync
              label="Product"
              name={`products.${index}.id`}
              placeholder="Choose Products"
              options={filterProducts(watch(`products.${index}.id`), products)}
              errorMessage={errors?.[`products.${index}.id`]}
              control={control}
              search={(val) => searchProducts([watch(`products.${index}.id`)], val)}
              required={true}
              callback={(id) => fetchProductInfo(id)}
            />
          </div>
        </div>
        <ProductShopAddresses index={index} control={control} errors={errors} watch={watch} setValue={setValue} register={register}/>
        <div className="row pt-3">
          <div className='w-50 number-input-wrapper'>
            <NumberInput
              label='Price'
              name={`products.${index}.product_price`}
              register={register}
              errorMessage={errors?.[`products.${index}.product_price`]}
              required={true}
            />
          </div>
          <div className='w-50 number-input-wrapper'>
            <NumberInput
              label='Dealing Price'
              name={`products.${index}.dealing_price`}
              register={register}
              errorMessage={errors?.[`products.${index}.dealing_price`]}
              // required={true}
            />
          </div>
        </div>
        <div className="row">
          <ReactSelectInput
            label="Status"
            name={`products.${index}.status`}
            control={control}
            errorMessage={errors?.[`products.${index}.status`]}
            options={data?.orderProductStatuses}
            required={true}
          />
        </div>
        <div className="row">
          <TextareaInput
            // required={watch(`products.${index}.is_modified`)}
            label="Comment"
            name={`products.${index}.comment`}
            className="col-12"
            register={register}
            watch={watch}
            errorMessage={errors?.[`products.${index}.comment`]}
          />
        </div>
      </div>
      <div className="card-footer d-flex justify-content-between align-items-center">
        <button
          type="button"
          onClick={close}
          className="btn btn-danger btn-hover-scale btn-sm mr-3"
        >
          cancel
        </button>
        <button
          type="button"
          onClick={() => handleSave()}
          className="btn btn-primary btn-hover-scale btn-sm"
        >
          save
        </button>
      </div>
    </div>
  );
}